// replacement for deprecated String.substr
const substr = (s: string, start: number, length?: number) => {
  const size = s.length;
  let intStart = start;
  if (intStart === -Infinity) {
    intStart = 0;
  } else if (intStart < 0) {
    intStart = Math.max(size + intStart, 0);
  } else {
    intStart = Math.min(intStart, size);
  }
  let intLength = length ?? size;
  intLength = Math.max(Math.min(intLength, size), 0);
  let intEnd = Math.min(intStart + intLength, size);
  return s.substring(intStart, intEnd);
};

export default substr;
